import { z } from 'zod'

import { GamSetupOrderSlice } from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/sections/SetupPrebidStackSection/hooks/useGetGamSetupOrders'
import { zNumericIntegerString } from 'providers/zod/types'

export const schema = z.object({
  bannerTemplateId: zNumericIntegerString.optional(),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (gamSetupOrder?: GamSetupOrderSlice): Schema => {
  const { bannerTemplateId } = gamSetupOrder ?? {}

  return {
    bannerTemplateId,
  }
}
